module.exports = __webpack_public_path__ + "__static/site-1783523783704/img/crocodile-mobile-portuguese.d2b0f64c.jpg";